/* SWT Social Feed (Homepage V2, item 5)
   - Desktop arrows + editor block focus
   - Post videos: desktop = play on hover, phone = play the fully visible one,
     tablet = touch and hold to play (release to pause). One video at a time.
   - Product popup on thumbnail hover (mouse) / first tap (touch) / keyboard focus. */
(function () {
  if (customElements.get('swt-social-feed')) return;

  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var reduceMotion = mq('(prefers-reduced-motion: reduce)').matches;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var noAuto = reduceMotion || saveData;
  var HOLD_MS = 550;
  var HOVER_MS = 180;
  var SETTLE_MS = 250;
  var current = null;
  var raf = null;
  var lastPointer = 'mouse';

  document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);

  function mode() {
    if (mq('(hover: hover) and (pointer: fine)').matches) return 'desktop';
    return mq('(min-width: 750px)').matches ? 'tablet' : 'phone';
  }

  function tick() {
    raf = null;
    if (!current || !current.sfVideo) return;
    var v = current.sfVideo;
    if (v.duration) current.style.setProperty('--sf-p', (v.currentTime / v.duration).toFixed(4));
    if (!v.paused) raf = window.requestAnimationFrame(tick);
  }

  function setBtn(card, playing) {
    var btn = card.querySelector('[data-sf-vbtn]');
    if (btn) btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
  }

  /* Phones that play HLS natively (iPhone, most Android) get the adaptive stream: lighter and quicker to start. */
  var canHls = (function () {
    try { return !!document.createElement('video').canPlayType('application/vnd.apple.mpegurl'); } catch (e) { return false; }
  })();

  /* Start downloading a card's video early (touch start / mouse enter) so playback starts right away. */
  function prime(card) {
    var video = card.sfVideo;
    if (!video || video.getAttribute('src')) return;
    var src = video.dataset.src;
    if (mode() === 'phone' && canHls && video.dataset.srcHls) src = video.dataset.srcHls;
    if (!src) return;
    video.preload = 'auto';
    video.src = src;
  }

  function startCard(card) {
    var video = card.sfVideo;
    if (!video) return;
    if (current && current !== card) stopCard(current, false);
    current = card;
    prime(card);
    video.muted = true;
    var p = video.play();
    if (p && p.catch) p.catch(function () { if (current === card) stopCard(card, false); });
  }

  function stopCard(card, keepFrame) {
    var video = card.sfVideo;
    if (!video) return;
    video.pause();
    card.classList.remove('is-playing');
    card.sfManual = false;
    if (current === card) current = null;
    if (keepFrame) return;
    card.classList.remove('is-shown');
    /* Rewind after the fade-out so the next play starts from the first frame. */
    window.clearTimeout(card.sfRewind);
    card.sfRewind = window.setTimeout(function () {
      if (current !== card && video.readyState > 0) {
        try { video.currentTime = 0; } catch (e) {}
        card.style.setProperty('--sf-p', '0');
      }
    }, 500);
  }

  class SwtSocialFeed extends HTMLElement {
    connectedCallback() {
      if (this.sfBound) return;
      this.rail = this.querySelector('[data-sf-rail]');
      if (!this.rail) return;
      this.sfBound = true;
      this.prev = this.querySelector('[data-sf-prev]');
      this.next = this.querySelector('[data-sf-next]');
      this.arrows = this.querySelector('[data-sf-arrows]');

      var self = this;
      var rafScroll = null;
      this.onScroll = function () {
        if (rafScroll) window.cancelAnimationFrame(rafScroll);
        rafScroll = window.requestAnimationFrame(function () { self.updateArrows(); });
      };
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      this.rail.addEventListener('scroll', function () { self.closePop(); }, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      /* The section CSS loads async, so re-check once the rail gets its real size. */
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.onScroll);
        this.ro.observe(this.rail);
      }
      window.addEventListener('load', this.onScroll, { once: true });
      if (this.prev) this.prev.addEventListener('click', function () { self.page(-1); });
      if (this.next) this.next.addEventListener('click', function () { self.page(1); });

      this.onBlockSelect = function (event) {
        if (!self.contains(event.target)) return;
        var item = event.target.closest('.swt-sf__item');
        if (item) self.scrollToItem(item);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.bindVideos();
      this.bindPopups();
      this.updateArrows();
    }

    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('resize', this.onScroll);
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.onDocDown) document.removeEventListener('pointerdown', this.onDocDown, true);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      if (current && this.contains(current)) stopCard(current, false);
    }

    /* ---------- Rail ---------- */
    page(direction) {
      var item = this.rail.querySelector('.swt-sf__item');
      var gap = parseFloat(window.getComputedStyle(this.rail).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : this.rail.clientWidth;
      var perPage = Math.max(1, Math.floor((this.rail.clientWidth + gap) / step));
      this.rail.scrollBy({ left: direction * perPage * step, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    scrollToItem(item) {
      var pad = parseFloat(window.getComputedStyle(this.rail).paddingLeft) || 0;
      this.rail.scrollTo({ left: Math.max(0, item.offsetLeft - pad), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    updateArrows() {
      if (!this.prev || !this.next) return;
      var max = this.rail.scrollWidth - this.rail.clientWidth;
      if (this.arrows) this.arrows.hidden = max <= 2;
      this.prev.disabled = this.rail.scrollLeft <= 2;
      this.next.disabled = this.rail.scrollLeft >= max - 2;
    }

    /* ---------- Videos ---------- */
    bindVideos() {
      var self = this;
      this.videoCards = Array.prototype.slice.call(this.querySelectorAll('[data-sf-video-card]'));
      if (!this.videoCards.length) return;
      this.style.setProperty('--sf-hold', HOLD_MS + 'ms');

      this.videoCards.forEach(function (card) {
        var video = card.querySelector('[data-sf-video]');
        var media = card.querySelector('.swt-sf__media');
        var btn = card.querySelector('[data-sf-vbtn]');
        if (!video || !media) return;
        card.sfVideo = video;
        card.sfRatio = 0;
        video.muted = true;

        video.addEventListener('playing', function () {
          if (current !== card) { video.pause(); return; }
          card.classList.add('is-playing', 'is-shown');
          setBtn(card, true);
          if (!raf) raf = window.requestAnimationFrame(tick);
        });
        video.addEventListener('pause', function () {
          card.classList.remove('is-playing');
          setBtn(card, false);
        });

        /* Desktop: hover (and keyboard focus) plays a preview */
        /* Small hover delay so sweeping the mouse across the row doesn't start every video. */
        card.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse' || noAuto || mode() !== 'desktop') return;
          prime(card);
          window.clearTimeout(card.sfHoverT);
          card.sfHoverT = window.setTimeout(function () { startCard(card); }, HOVER_MS);
        });
        card.addEventListener('pointerleave', function (e) {
          if (e.pointerType !== 'mouse') return;
          window.clearTimeout(card.sfHoverT);
          if (card.sfManual) return;
          if (current === card) stopCard(card, false);
        });
        media.addEventListener('focus', function () {
          if (noAuto || mode() !== 'desktop' || !media.matches(':focus-visible')) return;
          startCard(card);
        });
        media.addEventListener('blur', function () {
          if (current === card && !card.sfManual && mode() === 'desktop') stopCard(card, false);
        });

        /* Play / pause button (phone + desktop) */
        if (btn) {
          btn.addEventListener('click', function () {
            if (card.classList.contains('is-playing')) {
              card.sfUserPaused = true;
              stopCard(card, true);
            } else {
              card.sfUserPaused = false;
              startCard(card);
              card.sfManual = true;
            }
          });
        }

        /* Tablet: touch and hold to play, release to pause */
        var hold = null;
        var cancelHold = function () {
          if (hold) { window.clearTimeout(hold.t); hold = null; }
          card.classList.remove('is-pressing');
        };
        media.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' || mode() !== 'tablet') return;
          prime(card);
          cancelHold();
          hold = { x: e.clientX, y: e.clientY, t: 0 };
          card.classList.add('is-pressing');
          hold.t = window.setTimeout(function () {
            card.classList.remove('is-pressing');
            card.sfHolding = true;
            startCard(card);
          }, HOLD_MS);
        });
        media.addEventListener('pointermove', function (e) {
          if (!hold) return;
          if (Math.abs(e.clientX - hold.x) > 10 || Math.abs(e.clientY - hold.y) > 10) cancelHold();
        });
        var endHold = function () {
          cancelHold();
          if (card.sfHolding) {
            card.sfHolding = false;
            card.sfSuppressUntil = Date.now() + 700;
            if (current === card) stopCard(card, false);
          }
        };
        media.addEventListener('pointerup', endHold);
        media.addEventListener('pointercancel', endHold);
        media.addEventListener('pointerleave', endHold);
        media.addEventListener('click', function (e) {
          if (card.sfSuppressUntil && Date.now() < card.sfSuppressUntil) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }, true);
        media.addEventListener('contextmenu', function (e) {
          if (mode() === 'tablet' || card.sfHolding) e.preventDefault();
        });
      });

      /* Phone: play the fully visible video. All sizes: stop a video that scrolls away. */
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var card = entry.target.closest('[data-sf-video-card]');
            if (card) card.sfRatio = entry.isIntersecting ? entry.intersectionRatio : 0;
          });
          /* Stop a video that leaves the screen at once; pick the next one after the swipe settles. */
          if (current && self.contains(current) && current.sfRatio < 0.5) stopCard(current, false);
          window.clearTimeout(self.settleT);
          self.settleT = window.setTimeout(function () { self.pickVisible(); }, SETTLE_MS);
        }, { threshold: [0, 0.25, 0.5, 0.75, 0.9, 0.98, 1] });
        this.videoCards.forEach(function (card) {
          var media = card.querySelector('.swt-sf__media');
          if (media) self.io.observe(media);
        });
      }

      this.onVisibility = function () {
        if (document.hidden && current && self.contains(current)) stopCard(current, true);
        else if (!document.hidden) self.pickVisible();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    pickVisible() {
      if (!this.videoCards || !this.videoCards.length) return;
      if (current && this.contains(current) && current.sfRatio < 0.5) stopCard(current, false);
      if (noAuto || document.hidden || mode() !== 'phone') return;
      if (current && current.sfManual && current.sfRatio >= 0.5) return;
      var best = null;
      this.videoCards.forEach(function (card) {
        if (card.sfUserPaused || card.sfRatio < 0.9) return;
        if (!best || card.sfRatio > best.sfRatio + 0.01) best = card;
      });
      if (best && best !== current) startCard(best);
    }

    /* ---------- Product popup ---------- */
    bindPopups() {
      var self = this;
      var tags = Array.prototype.slice.call(this.querySelectorAll('[data-sf-pop-open]'));
      if (!tags.length) return;

      tags.forEach(function (tag) {
        var post = tag.closest('.swt-sf__post');
        var pop = post && post.querySelector('[data-sf-pop="' + tag.getAttribute('data-sf-pop-open') + '"]');
        if (!pop) return;
        tag.sfPop = pop;

        tag.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse') return;
          self.cancelClose();
          self.openPopFor(tag);
        });
        tag.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') self.scheduleClose(); });
        pop.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self.cancelClose(); });
        pop.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') self.scheduleClose(); });

        tag.addEventListener('click', function (e) {
          if (lastPointer === 'mouse') return;
          if (self.openTag !== tag) {
            e.preventDefault();
            self.openPopFor(tag);
          }
        });
        tag.addEventListener('focus', function () {
          if (tag.matches(':focus-visible')) self.openPopFor(tag);
        });

        var close = pop.querySelector('[data-sf-pop-close]');
        if (close) close.addEventListener('click', function () {
          self.closePop();
          tag.focus({ preventScroll: true });
        });
      });

      this.onDocDown = function (e) {
        if (!self.openPop) return;
        if (self.openPop.contains(e.target) || (self.openTag && self.openTag.contains(e.target))) return;
        self.closePop();
      };
      document.addEventListener('pointerdown', this.onDocDown, true);

      this.addEventListener('focusout', function (e) {
        if (!self.openPop) return;
        var to = e.relatedTarget;
        if (to && (self.openPop.contains(to) || self.openTag.contains(to))) return;
        self.closePop();
      });
      this.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !self.openPop) return;
        var tag = self.openTag;
        self.closePop();
        if (tag) tag.focus({ preventScroll: true });
      });
    }

    openPopFor(tag) {
      if (this.openTag === tag) return;
      this.closePop();
      tag.sfPop.classList.add('is-open');
      tag.setAttribute('aria-expanded', 'true');
      this.openTag = tag;
      this.openPop = tag.sfPop;
    }

    closePop() {
      this.cancelClose();
      if (!this.openPop) return;
      this.openPop.classList.remove('is-open');
      if (this.openTag) this.openTag.setAttribute('aria-expanded', 'false');
      this.openPop = null;
      this.openTag = null;
    }

    scheduleClose() {
      var self = this;
      this.cancelClose();
      this.closeTimer = window.setTimeout(function () { self.closePop(); }, 180);
    }

    cancelClose() {
      if (this.closeTimer) window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

  customElements.define('swt-social-feed', SwtSocialFeed);
})();
